<template>
  <main class="container register-class">
    <div class="d-table mx-auto mb-4">
      <h2 class="font-heading-1 font-family-concended font-all-upper">Finish your registration</h2>
      <div class="underlined darkgreen container"></div>
    </div>
    <div class="canada-learner col-lg-12 col-md-12 col-12">
      <p class="text-center">
        Canada learners: to register for Starbucks Coffee Academy, go to
        <a
          href="//canada.starbuckscoffeeacademy.com"
          class="link-click"
        >Canada.StarbucksCoffeeAcademy.com</a>.
      </p>
    </div>
    <form action @submit.prevent="handleSubmit">
      <transition name="fade">
        <div
          class="alert fade in alert-dismissible show"
          v-if="custom"
          :class="this.error? 'alert-danger' :'alert-success'"
        >
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
            v-on:click="remove"
          >
            <span aria-hidden="true" style="font-size:20px">×</span>
          </button>
          <strong>{{customMessage}}</strong>
          {{ this.customData }}
        </div>
      </transition>
      <div class="row">
        <div class="col-md-10 mx-auto">
          <div class="col-md-12">
            <div class="form-group">
              <label
                for="first_name"
                class="text-danger"
                v-if="errors.has('first_name')"
              >{{errors.first('first_name')}}</label>
              <label for="first_name" v-else>First name</label>
              <input
                type="text"
                :class="{'form-control': true, 'is-invalid': errors.has('first_name') }"
                id="first_name"
                v-model="first_name"
                v-validate="'required'"
                name="first_name"
                aria-label="Enter your first name"
                placeholder="Enter your first name"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label
                for="last_name"
                class="text-danger"
                v-if="errors.has('last_name')"
              >{{errors.first('last_name')}}</label>
              <label for="last_name" v-else>Last name</label>
              <input
                type="text"
                :class="{'form-control': true, 'is-invalid': errors.has('last_name') }"
                id="last_name"
                v-model="last_name"
                v-validate="'required'"
                name="last_name"
                aria-label="Enter your last name"
                placeholder="Enter your last name"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label
                for="Email"
                class="text-danger"
                v-if="errors.has('Email')"
              >{{errors.first('Email')}}</label>
              <label for="Email" v-else>Email</label>
              <input
                type="text"
                :class="{'form-control': true, 'is-invalid': errors.has('Email') }"
                id="Email"
                v-model="email"
                v-validate="'required|email'"
                name="Email"
                aria-label="Enter your email"
                placeholder="Enter your email"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label
                for="phoneno"
                class="text-danger"
                v-if="errors.has('phoneno')"
              >{{errors.first('phoneno')}}</label>
              <label for="phoneno" v-else>Phone number (Optional)</label>
              <the-mask
                type="int"
                :class="{'form-control': true, 'is-invalid': errors.has('phoneno') }"
                id="phoneno"
                v-model="phone_number"
                v-validate="'valid-phone'"
                aria-label="Enter your phone number"
                name="phoneno"
                autocomplete="off"
                placeholder="Enter your phone number"
                mask="###-###-####"
              />
              <!-- currentmod -->
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group row flex-column p-3">
              <label for="select" class="text-danger" v-if="$store.state.countryvalid">
                Canada learners: to register for Starbucks Coffee Academy, go to
                <a
                  href="//canada.starbuckscoffeeacademy.com"
                  class="link-click"
                >Canada.StarbucksCoffeeAcademy.com</a>
              </label>
              <label for="select" v-else>Region</label>
              <div class="select-font">
                <select
                  class="form-control custom-select-data"
                  :class="{'is-invalid': $store.state.countryvalid }"
                  id="select"
                  v-model="country"
                  @change="someHandler()"
                >
                  <option value disabled>Choose a region</option>
                  <option value="United Kingdom">United Kingdom</option>
                  <option value="Brazil">Brazil</option>
                  <option value="United States of America">United States</option>
                  <option value="India">India</option>
                  <option value="Canada">Canada</option>
                </select>
                <span
                  class="fas fa-caret-down custom-icon"
                  :class="{'countryinvalid': $store.state.countryvalid }"
                ></span>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-12">
            <div class="form-group">
              <label
                for="partner_number"
                class="text-danger"
                v-if="errors.has('partner_number')"
              >{{errors.first('partner_number')}}</label>
              <label for="partner_number" v-else>Partner number (Optional)</label>
              <span class="input-group-partner px-2">
                <strong>US -</strong>
                <input
                  type="text"
                  :class="{'form-control-partner': true, 'is-invalid': errors.has('partner_number') }"
                  class="border-0"
                  id="partner_number"
                  v-model="partner_number"
                  name="partner_number"
                  aria-label="Enter your Partner number"
                  placeholder="Enter your Partner number"
                />
              </span>
            </div>
          </div> -->
          <div class="col-md-12">
            <label id="ssn1" class="font-family-bold">What is your affiliation to Starbucks?</label>
            <b-form-group aria-labelledby="ssn1" class="custom-radio-group">
              <b-form-radio
                v-model="selected"
                name="some-radios"
                value="starbucks partner"
                class="font-paragraph-1 font-grey register-custom-radio"
                aria-label="Starbucks-partner"
              >I am a Starbucks partner</b-form-radio>
              <b-form-radio
                v-model="selected"
                name="some-radios"
                value="starbucks associate"
                class="font-paragraph-1 font-grey register-custom-radio"
                aria-label="Starbucks-associate"
              >I am a Starbucks associate</b-form-radio>
              <b-form-radio
                v-model="selected"
                name="some-radios"
                value="former starbucks partner"
                class="custom-radio-3 font-paragraph-1 font-grey register-custom-radio"
                aria-label="Starbucks-customer"
              >I am a former Starbucks partner</b-form-radio>
              <b-form-radio
                v-model="selected"
                name="some-radios"
                value="starbucks customer"
                class="font-paragraph-1 font-grey register-custom-radio"
                aria-label="Starbucks-customer"
              >I am a Starbucks customer</b-form-radio>
            </b-form-group>
          </div>
          <div class="col-md-12">
            <label class="font-family-bold">Selected Courses</label>
            <br />
            <div class="d-inline-block">
              <span
                class="mb-5 mx-1"
                v-for="(selectedCourse,i) in selectCourseObjs"
                :key="selectedCourse.id"
              >
                <span class="course-chips">
                  <template v-if="i == 0">{{selectedCourse.name}}</template>
                  <template v-else-if="i == 1">{{selectedCourse.name}}</template>
                  <template v-else>
                    <span>
                      <span
                        @click="removeThisElement(selectedCourse)"
                        tabindex="0"
                        :aria-label="`remove ${selectedCourse.name}`"
                        role="buttom"
                        class="removeCourse"
                      >X</span>
                      <span>{{selectedCourse.name}}</span>
                    </span>
                  </template>
                </span>
              </span>
            </div>
            <br />
            <button
              type="button"
              aria-label="Add more courses"
              @click="closeThisModal()"
              class="outline-button-primary border-orange font-orange bg-white font-bold px-4 py-1"
            >
              <span class="removeCourse">+</span>Select more courses
            </button>
          </div>
          <section class="col-md-12 my-5">
            <p id="border-display" class="border-darkgreen-left font-micro mt-2">
              By providing your phone number, you consent and agree to receive ads or telemarketing messages via autodialed calls or robocalls/robotexts. However, you are not required to consent as a condition of purchasing any goods or services. By clicking Submit, I authorize representatives of Arizona State University and Starbucks to contact me using the contact information I have provided by email, telephone calls, and text messages. Up to 5 text messages/month. Text HELP for Help or text STOP to end text messages. Note for Starbucks partners, Information provided to partners as a part of official Starbucks training supersedes and takes priority over information—including conflicting or discrepant information—presented on Starbucks Global Academy.
              <a
                href="https://d1ae7fb31f7a8ef466d3-5298a79f5e521f276537975a1b0a0b03.ssl.cf1.rackcdn.com/global-onward/Terms_of_Use_18.5.23.pdf"
                class="font-black border-black-thin"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms &
                Conditions.
              </a>&nbsp;View our
              <a
                href="https://www.asu.edu/privacy/"
                class="font-black border-black-thin"
                target="_blank"
                rel="noopener noreferrer"
              >Privacy Policy.&nbsp;</a>
            </p>
          </section>
        </div>
      </div>
      <button
        type="submit"
        v-if="!tryRegister"
        class="btn btn-cta mx-auto"
        :disabled="!isComplete"
      >Submit</button>
      <button v-else class="btn btn-cta mx-auto" disabled>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="loading"
          width="31.239"
          height="28"
          viewBox="0 0 31.239 28"
        >
          <g transform="translate(0 -1.797)">
            <g transform="translate(0 1.797)">
              <path
                class="a"
                d="M13.823,29.8a14,14,0,0,1,0-28,13.928,13.928,0,0,1,13.823,14,.791.791,0,1,1-1.581,0A12.337,12.337,0,0,0,13.822,3.4a12.4,12.4,0,0,0,0,24.8,12.275,12.275,0,0,0,10.559-6.119.784.784,0,0,1,1.082-.283.807.807,0,0,1,.28,1.1A13.855,13.855,0,0,1,13.823,29.8Z"
                transform="translate(0 -1.797)"
              />
            </g>
            <g transform="translate(20.311 10.089)">
              <path
                class="a"
                d="M30.17,18.214a.887.887,0,0,1-.45-.123l-5.561-3.284a.887.887,0,1,1,.9-1.527l4.852,2.865,3.123-4.473a.887.887,0,0,1,1.455,1.015L30.9,17.833A.886.886,0,0,1,30.17,18.214Z"
                transform="translate(-23.723 -11.292)"
              />
            </g>
          </g>
        </svg>
      </button>
    </form>
  </main>
</template>
<script>
import registerService from "../../services/register";
import axios from "axios";
export default {
  name: "RegisterComponent",
  props: {
    selectedCourses: Array,
    selectCourseObjs: Array
  },
  data() {
    return {
      first_name: this.$store.state.first_name,
      last_name: this.$store.state.last_name,
      phone_number: this.$store.state.phone_number,
      email: this.$store.state.email,
      country: this.$store.state.country,
      modules: this.selectCourseObjs,
      custom: false,
      error: false,
      success: false,
      customSuccessData: "",
      customErrorData: "",
      customMessage: "",
      selected: "starbucks partner",
      tryRegister: false
    };
  },
  created() {
    let self = this;
    this.$validator.extend("valid-phone", {
      getMessage(field, val) {
        return "Phone number must be numeric and contain 10 digits";
      },
      validate(value, field) {
        let phone = self.phone_number;
        if (phone.length === 10) {
          return true;
        } else {
          return false;
        }
      }
    });
  },
  methods: {
    someHandler() {
      let country = this.country;
      if (country === "Canada") {
        this.$store.state.countryvalid = true;
      } else {
        this.$store.state.countryvalid = false;
      }
    },
    closeThisModal() {
      $("#exampleModal").modal("toggle");
    },
    removeThisElement(ele) {
      let index = this.selectedCourses.indexOf(ele.name);
      this.selectedCourses.splice(index, 1);
      // console.log(index);
      this.selectCourseObjs.splice(index, 1);
    },
    writeToSheet(bodyFormData) {
      console.log(bodyFormData);
      let url =
        "https://script.google.com/macros/s/AKfycbxyMtcp14dknf-M-mC6U3D0fI7UnoCw7c4L9hsBwRtvxiCrBfo/exec";
      jQuery.ajax({
        url: url,
        type: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded"
        },
        data: bodyFormData,
        success: function() {
          console.log("success");
        },
        error: function() {
          console.log("error");
        }
      });
    },
    handleSubmit(e) {
      let formVariables = {
        email: this.email,
        first_name: this.first_name,
        last_name: this.last_name,
        phone: this.phone_number,
        country: this.country
      };
      this.$validator.validate().then(async valid => {
        if (valid) {
          this.tryRegister = true;
          try {
            const response = await registerService.register({
              email: this.email,
              fName: this.first_name,
              lName: this.last_name,
              phone: this.phone_number,
              country: this.country.indexOf("OTH") > -1 ? "" : this.country,
              courseId: this.modules
            });
            // Write go googlesheet
            // this.writeToSheet(formVariables);
            this.success = true;
            this.custom = true;
            this.customMessage = "Success";
            this.customData = "User Created";
            //this.$store.state.currentStep = 1;
            if (this.first_name != "embtest") {
              dataLayer.push({
                event: "rfi submit",
                username: this.first_name,
                email: this.email,
                action: "rfi submit error"
              });
            }
            if (response.data.error) {
              this.customMessage = true;
              this.error = true;
              this.customMessage = "Error! ";
              this.tryRegister = false;
              this.customData = response.data.error.details;
              // dataLayer.push({
              //   event: "rfi submit",
              //   username: this.first_name,
              //   email: this.email,
              //   action: "rfi submit error"
              // });
            } else {
              if (response.data.status == "EXISTING_USER") {
                this.$store.state.userExist = 1;
              } else {
                this.$store.state.userExist = 0;
              }
              this.$store.state.currentStep = 1;
              // console.log("Success created the content");
              try {
                const crmContent = await registerService.crmContent({
                  email: this.email,
                  fName: this.first_name,
                  lName: this.last_name,
                  phone: this.phone_number,
                  courseId: this.modules,
                  starbucksPartnerEmployee: this.selected
                });
              } catch (err) {
                console.error("Error creating the contact list in send grid");
              }
            }
          } catch (err) {
            this.custom = true;
            this.error = true;
            this.customMessage = "Error";
            this.tryRegister = false;
            dataLayer.push({
              event: "rfi submit",
              username: this.first_name,
              email: this.email,
              action: "rfi submit error"
            });
            this.customData = "Please contact administrator";
          }
        }
      });
    },
    remove() {
      this.custom = false;
    }
  },
  computed: {
    isComplete() {
      return (
        this.email &&
        this.first_name &&
        this.last_name &&
        this.country &&
        !this.$store.state.countryvalid
      );
    }
  },
  mounted() {
    $(".custom-radio input").attr("role", "radiogroup");
    $(".custom-radio-group>div").removeAttr("role");
  },
  beforeMount() {
    const dict = {
      custom: {
        first_name: {
          required: () => "First name is required"
        },
        last_name: {
          required: () => "Last name is required"
        },
        phoneno: {
          required: () => "Phone number is required"
        },
        Email: {
          required: () => "Email address is required"
        },
        select: {
          required: () => "This field is required"
        }
      }
    };
    this.$validator.localize("en", dict);
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
  .fade-leave-to

  /* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
}
select#select::-ms-expand {
  display: none;
}
.custom-icon.countryinvalid {
  top: 60% !important;
}
@media screen and (max-width: 431px) {
  .custom-icon.countryinvalid {
    top: 66% !important;
  }
}
.modal-register .canada-learner p {
  font-size: 16px;
}
@media screen and (max-width: 767px) {
  .modal-register .canada-learner p {
    font-size: 15px;
  }
}
@media screen and (max-width: 359px) {
  .modal-register .canada-learner p {
    font-size: 13px;
  }
  .custom-radio-3.register-custom-radio {
    margin-bottom: 25px;
  }
}
.input-group-partner {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.form-control-partner {
  height: 50px !important;
  font-size: 1.2rem !important;
  font-family: dDinL, sans-serif;
  border: 2px solid transparent;
  -webkit-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
  width: 100%;
}
</style>